import { create } from "zustand";
import { InviteStudyDTO } from "../config/type";

type InviteStudyStore = {
  inviteStudyInfo: InviteStudyDTO;
  setInviteStudyInfo: (inviteStudyInfo: InviteStudyDTO) => void;
};

export const useInviteStudyStore = create<InviteStudyStore>((set) => ({
  inviteStudyInfo: {
    studyId: "",
    studyName: "",
    studyImageUrl: "",
    studyField: 0,
    totalWeeks: 0,
    studyStartDate: "",
    studyEndDate: "",
    daysOfWeek: [],
    studyDescription: "",
    studyContents: [],
  },
  setInviteStudyInfo: (inviteStudyInfo: InviteStudyDTO) =>
    set({ inviteStudyInfo }),
}));
